import { Outlet } from 'react-router-dom';
import { Header } from './Header';

export function Layout(): JSX.Element {
  return (
    <div className="flex min-h-full flex-col">
      <Header />
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-8">
        <Outlet />
      </main>
      <footer className="border-t border-ntr-primary/10 bg-white px-6 py-3 text-center text-xs text-ntr-muted">
        NTR Engine · S21 frontend skeleton
      </footer>
    </div>
  );
}
